export enum DatumRouteName {
    Index = 'datum.index',
    Create = 'datum.create',
    Edit = 'datum.edit',
    Clone = 'datum.clone',
    DimensionsIndex = 'datum.dimensions.index',
    DimensionsCreate = 'datum.dimensions.create',
    DimensionsEdit = 'datum.dimensions.edit',
    DimensionsDetails = 'datum.dimensions.details',
    DimensionsComponentsIndex = 'datum.dimensions.components.index',
    DimensionsComponentsCreate = 'datum.dimensions.components.create',
    DimensionsComponentsEdit = 'datum.dimensions.components.edit',
    DimensionsComponentsDetails = 'datum.dimensions.components.details',
    DimensionsLimitsIndex = 'datum.dimensions.limits.index',
    DimensionsLimitsCreate = 'datum.dimensions.limits.create',
    DimensionsLimitsEdit = 'datum.dimensions.limits.edit',
    DimensionsLimitsDetails = 'datum.dimensions.limits.details',
    DimensionsPresentationsIndex = 'datum.dimensions.presentations.index',
    DimensionsPresentationsCreate = 'datum.dimensions.presentations.create',
    DimensionsPresentationsEdit = 'datum.dimensions.presentations.edit',
    DimensionsPresentationsDetails = 'datum.dimensions.presentations.details',
}

export default {
    path: 'datum',
    name: DatumRouteName.Index,
    component: () => import('./pages/index.vue'),
    meta: {
        label: 'Datum',
        icon: 'fal fa-puzzle-piece fa-fw',
        location: 'sidebar',
        permission: 'manage-datum',
        auth: true,
        group: 'main',
    },
    children: [
        {
            path: 'create',
            name: DatumRouteName.Create,
            component: () => import('./pages/index.vue'),
            meta: {
                auth: true,
                label: 'Create Datum',
                permission: 'manage-datum',
                group: 'main',
            },
        },
        {
            path: ':datumId/edit',
            name: DatumRouteName.Edit,
            component: () => import('./pages/index.vue'),
            meta: {
                auth: true,
                label: 'Edit Datum',
                permission: 'manage-datum',
                group: 'main',
            },
        },
        {
            path: ':datumId/clone',
            name: DatumRouteName.Clone,
            component: () => import('./pages/index.vue'),
            meta: {
                auth: true,
                label: 'Clone Datum',
                permission: 'manage-datum',
                group: 'main',
            },
        },
        {
            path: ':datumId/dimensions',
            name: DatumRouteName.DimensionsIndex,
            component: () => import('./pages/index.vue'),
            meta: {
                auth: true,
                label: 'Datum Dimensions',
                permission: 'manage-datum',
                group: 'main',
            },
            children: [
                {
                    path: 'create',
                    name: DatumRouteName.DimensionsCreate,
                    component: () => import('./pages/index.vue'),
                    meta: {
                        auth: true,
                        label: 'Create Datum Dimension',
                        permission: 'manage-datum',
                        group: 'main',
                    },
                },
                {
                    path: ':datumDimensionId/edit',
                    name: DatumRouteName.DimensionsEdit,
                    component: () => import('./pages/index.vue'),
                    meta: {
                        auth: true,
                        label: 'Edit Datum Dimension',
                        permission: 'manage-datum',
                        group: 'main',
                    },
                },
                {
                    path: ':datumDimensionId/details',
                    name: DatumRouteName.DimensionsDetails,
                    component: () => import('./pages/index.vue'),
                    meta: {
                        auth: true,
                        label: 'Datum Dimension Details',
                        permission: 'manage-datum',
                        group: 'main',
                    },
                },
                {
                    path: ':datumDimensionId/components',
                    name: DatumRouteName.DimensionsComponentsIndex,
                    component: () => import('./pages/index.vue'),
                    meta: {
                        auth: true,
                        label: 'Datum Dimension Components',
                        permission: 'manage-datum',
                        group: 'main',
                    },
                    children: [
                        {
                            path: 'create',
                            name: DatumRouteName.DimensionsComponentsCreate,
                            component: () => import('./pages/index.vue'),
                            meta: {
                                auth: true,
                                label: 'Create Datum Dimension Component',
                                permission: 'manage-datum',
                                group: 'main',
                            },
                        },
                        {
                            path: ':datumDimensionComponentId/edit',
                            name: DatumRouteName.DimensionsComponentsEdit,
                            component: () => import('./pages/index.vue'),
                            meta: {
                                auth: true,
                                label: 'Edit Datum Dimension Component',
                                permission: 'manage-datum',
                                group: 'main',
                            },
                        },
                    ],
                },
                {
                    path: ':datumDimensionId/limits',
                    name: DatumRouteName.DimensionsLimitsIndex,
                    component: () => import('./pages/index.vue'),
                    meta: {
                        auth: true,
                        label: 'Datum Dimension Limits',
                        permission: 'manage-datum',
                        group: 'main',
                    },
                    children: [
                        {
                            path: 'create',
                            name: DatumRouteName.DimensionsLimitsCreate,
                            component: () => import('./pages/index.vue'),
                            meta: {
                                auth: true,
                                label: 'Create Datum Dimension Limit',
                                permission: 'manage-datum',
                                group: 'main',
                            },
                        },
                        {
                            path: ':datumDimensionLimitId/edit',
                            name: DatumRouteName.DimensionsLimitsEdit,
                            component: () => import('./pages/index.vue'),
                            meta: {
                                auth: true,
                                label: 'Edit Datum Dimension Limit',
                                permission: 'manage-datum',
                                group: 'main',
                            },
                        },
                    ],
                },
                {
                    path: ':datumDimensionId/presentations',
                    name: DatumRouteName.DimensionsPresentationsIndex,
                    component: () => import('./pages/index.vue'),
                    meta: {
                        auth: true,
                        label: 'Edit Datum Presentations',
                        permission: 'manage-datum',
                        group: 'main',
                    },
                    children: [
                        {
                            path: 'create',
                            name: DatumRouteName.DimensionsPresentationsCreate,
                            component: () => import('./pages/index.vue'),
                            meta: {
                                auth: true,
                                label: 'Create Datum Dimension Presentation',
                                permission: 'manage-datum',
                                group: 'main',
                            },
                        },
                        {
                            path: ':datumDimensionPresentationId/edit',
                            name: DatumRouteName.DimensionsPresentationsEdit,
                            component: () => import('./pages/index.vue'),
                            meta: {
                                auth: true,
                                label: 'Edit Datum Dimension Presentation',
                                permission: 'manage-datum',
                                group: 'main',
                            },
                        },
                    ],
                },
            ],
        },
    ],
}
